/* pi-unit-variants (#238): when a multi-unit tier is selected on a product with
   real variants, render one dropdown PER UNIT so unit 1 and unit 2 can be
   DIFFERENT variants. Talks to each PI section via its root element's __geUV
   bridge (set by the main PI script). Liquid-free ON PURPOSE - the deploy
   pipeline externalizes this block to a shared asset (lib/pi-section-split.js),
   so it adds ~0 bytes to the 256KB section budget. Dropdowns ALWAYS (native
   selects stay clean with many variants, and on mobile). */
(function () {
  'use strict';

  /* Pure core - exposed for tests (harmless in production).
     Pricing: the tier's baked data-price-cents encodes the DISCOUNTED total for
     qty x the render-time basis variant (data-basis-cents). The same discount
     RATIO is applied to whatever mix of units the buyer picks:
       total = round(sum(unit prices) * tierCents / (basisCents * qty))
     When every unit is the basis variant the sum telescopes and total ==
     tierCents exactly - no drift against the baked tier price. */
  function uvComputeTotalCents(unitIds, priceById, tierCents, basisCents, qty) {
    var sum = 0;
    for (var i = 0; i < unitIds.length; i++) sum += priceById[String(unitIds[i])] || 0;
    var ratio = (tierCents > 0 && basisCents > 0 && qty > 0) ? tierCents / (basisCents * qty) : 1;
    return Math.round(sum * ratio);
  }
  function uvMergeLines(unitIds) {
    var counts = {}, order = [];
    for (var i = 0; i < unitIds.length; i++) {
      var id = String(unitIds[i]);
      if (!counts[id]) { counts[id] = 0; order.push(id); }
      counts[id] += 1;
    }
    return order.map(function (id) { return { id: id, quantity: counts[id] }; });
  }
  try { window.__geUVCore = { computeTotalCents: uvComputeTotalCents, mergeLines: uvMergeLines }; } catch (e) {}

  function initUnitVars(root) {
    var uv = root.__geUV;
    if (!uv || !uv.data) return;
    var all = Array.isArray(uv.data.variants) ? uv.data.variants : [];
    var variants = all.filter(function (v) { return v && v.available !== false; });
    if (variants.length < 2) return; /* single variant (incl. Default Title) - nothing to pick */
    var priceById = {};
    for (var i = 0; i < variants.length; i++) priceById[String(variants[i].id)] = variants[i].price || 0;

    var panel = document.createElement('div');
    panel.className = 'pi-uv-panel';
    panel.setAttribute('data-ge-uv-panel', '');
    panel.hidden = true;
    /* After the tier list; fall back to just above the ATC button. */
    var tiersWrap = root.querySelector('[data-tier-count]');
    if (tiersWrap && tiersWrap.parentNode) tiersWrap.parentNode.insertBefore(panel, tiersWrap.nextSibling);
    else {
      var atc = root.querySelector('[data-pi-atc]');
      if (atc && atc.parentNode) atc.parentNode.insertBefore(panel, atc);
      else return;
    }

    var unitIds = [];

    function tierInfo() {
      var t = uv.getTier ? uv.getTier() : null;
      var qty = (t && parseInt(t.dataset.qty, 10)) || (uv.getQty ? uv.getQty() : 1) || 1;
      return {
        qty: qty,
        cents: (t && parseInt(t.dataset.priceCents, 10)) || 0,
        basis: (t && parseInt(t.dataset.basisCents, 10)) || 0
      };
    }

    function seedVariantId() {
      var cur = uv.getVariant ? uv.getVariant() : null;
      if (cur && priceById[String(cur.id)] !== undefined) return String(cur.id);
      return String(variants[0].id);
    }

    function recompute() {
      var info = tierInfo();
      if (info.qty < 2) { uv.items = null; return; }
      uv.items = uvMergeLines(unitIds);
      var total = uvComputeTotalCents(unitIds, priceById, info.cents, info.basis, info.qty);
      if (total > 0 && uv.setPrice) uv.setPrice(total);
    }

    function render() {
      var info = tierInfo();
      if (info.qty < 2) { panel.hidden = true; panel.innerHTML = ''; unitIds = []; uv.items = null; return; }
      var seed = seedVariantId();
      while (unitIds.length < info.qty) unitIds.push(seed);
      unitIds.length = info.qty;
      /* Design pick (#238b): simple products get PILLS (with a colour swatch
         dot when the variant name is a real CSS colour); many-variant or
         multi-option products keep the dropdown (stays clean at any count). */
      var optCount = Array.isArray(uv.data.options) ? uv.data.options.length : 1;
      var usePills = variants.length <= 6 && optCount <= 1;
      var swatchOf = function (title) {
        try {
          var probe = new Option().style;
          probe.color = '';
          probe.color = String(title || '').toLowerCase();
          return probe.color ? probe.color : null;
        } catch (e) { return null; }
      };
      panel.innerHTML = '';
      for (var u = 0; u < info.qty; u++) (function (u) {
        var row = document.createElement('div');
        row.className = 'pi-uv-row';
        var num = document.createElement('span');
        num.className = 'pi-uv-num';
        num.textContent = '#' + (u + 1);
        row.appendChild(num);
        if (usePills) {
          var group = document.createElement('div');
          group.className = 'pi-uv-pills';
          group.setAttribute('role', 'radiogroup');
          group.setAttribute('aria-label', '#' + (u + 1));
          group.setAttribute('data-ge-uv-select', String(u));
          for (var i = 0; i < variants.length; i++) (function (v) {
            var pill = document.createElement('button');
            pill.type = 'button';
            pill.className = 'pi-uv-pill';
            pill.setAttribute('role', 'radio');
            pill.setAttribute('data-uv-val', String(v.id));
            var sw = swatchOf(v.title);
            if (sw) {
              var dot = document.createElement('span');
              dot.className = 'pi-uv-swatch';
              dot.style.background = sw;
              pill.appendChild(dot);
            }
            pill.appendChild(document.createTextNode(v.title || String(v.id)));
            var sync = function () {
              var on = String(v.id) === String(unitIds[u]);
              pill.classList.toggle('selected', on);
              pill.setAttribute('aria-checked', on ? 'true' : 'false');
            };
            sync();
            pill.addEventListener('click', function () {
              unitIds[u] = String(v.id);
              var kids = group.children;
              for (var k = 0; k < kids.length; k++) {
                var on = kids[k].getAttribute('data-uv-val') === String(unitIds[u]);
                kids[k].classList.toggle('selected', on);
                kids[k].setAttribute('aria-checked', on ? 'true' : 'false');
              }
              recompute();
            });
            group.appendChild(pill);
          })(variants[i]);
          row.appendChild(group);
        } else {
          var sel = document.createElement('select');
          sel.className = 'pi-uv-select';
          sel.setAttribute('data-ge-uv-select', String(u));
          sel.setAttribute('aria-label', '#' + (u + 1));
          for (var i = 0; i < variants.length; i++) {
            var opt = document.createElement('option');
            opt.value = String(variants[i].id);
            opt.textContent = variants[i].title || String(variants[i].id);
            if (String(variants[i].id) === String(unitIds[u])) opt.selected = true;
            sel.appendChild(opt);
          }
          sel.addEventListener('change', function () {
            unitIds[u] = sel.value;
            recompute();
          });
          row.appendChild(sel);
        }
        panel.appendChild(row);
      })(u);
      panel.hidden = false;
      recompute();
    }

    if (Array.isArray(uv.onTier)) uv.onTier.push(function () { render(); });
    render(); /* a default tier may already be selected at load */
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ge-uv="1"]');
    for (var i = 0; i < roots.length; i++) {
      var r = roots[i];
      if (!r.__geUVBooted) { r.__geUVBooted = true; try { initUnitVars(r); } catch (e) {} }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();